import React from 'react';
import { renderToString } from 'react-dom/server';

import { FileVideoIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class VideoInstruction extends InlineInstruction {
  protected static title = 'Video';

  get icon() {
    return renderToString(<FileVideoIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.VIDEO_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.VIDEO_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.VIDEO_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_VIDEO_INSTRUCTION_MODAL,
      { instructionId, isInline: true },
    );
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.video}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_VIDEO_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_VIDEO_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_VIDEO_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_VIDEO_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default VideoInstruction;
